module.exports = __webpack_public_path__ + "static/media/Северная ночь.12174a06.jpg";